export default __webpack_public_path__ + "static/t01-d532ce0b911c4a98a895be78a804232e.jpg";